<template lang="pug">
    #agentDrawer.v-card.mark-card.portal-drawer-dialog.portaldrawerDialog.drawer-flex-style(:height="windowHeight" :max-height="windowHeight" elevation='0' )
        div.drawer-form-flex
            //- 導引列
            v-card-title.d-flex.align-center.justify-between-space.px-0.pb-0(:class="isUpsideExtension ? 'pt-3':'pt-0'" style='border-bottom: 1px solid #E8E8E8;')
                v-col.closeBtn.pr-0(cols="auto")
                    v-btn.close-line.btn-none-effect(icon @click='onCloseDialog' tile :ripple="false")
                        v-icon(size='35') mdi-chevron-left
                v-col.d-flex.align-center.pl-0
                    span.ml-2.ellipsis-single(v-if='agent_detail_data.agent_name' style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-size: 18px; color: #444;") {{agent_detail_data.agent_name}}
                    span.ml-2.ellipsis-single(v-else style="font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; font-weight: 700;") Details
                v-col(cols="auto")
                    v-btn(icon @click='onCloseDialog' :disabled="addBtn_loading")
                        v-icon mdi-close

            //- 輸入欄位
            div.agent_input_area.flex-1
                div.pa-0.ma-0.mt-4.ml-4.pr-4(v-if='agent_detail_data')
                    div
                        v-row(no-gutters)
                            v-col.d-flex.justify-end.pr-0(cols='12')
                                v-btn.px-2.align-center(outlined dense height="30" @click="popAgentFieldDialog" :disabled='!editMode') 
                                    v-icon(color="#444") mdi-plus
                                    span(color="#444") {{ $t('AGENT.ADD_FIELD') }}
                    div.pa-0.ma-0.mt-2.ml-0.pr-0(v-if='agent_detail_data')
                        v-row(no-gutters).d-flex
                            v-col(cols="2")
                                v-btn(depressed icon fab @click="showAgentIconEditDialog" style="margin-top: -6px;")
                                    v-img(:src="select_icon_obj.path" max-width="44")
                            v-col(cols='10').agent-drawer-textarea-hint
                                v-textarea.span.textarea-style.mb-1(
                                    v-model='agent_detail_data.agent_name'
                                    no-resize
                                    rows='1'
                                    outlined
                                    dense
                                    :disabled='!editMode'
                                    style="font-family: 'Segoe UI',SegoeUI,'Noto Sans TC', sans-serif !important;font-weight: 400; font-size: 14px;"
                                )
                                    template(v-slot:append)
                        v-row.mt-2(no-gutters).d-flex
                            v-col(cols="2")
                                label.label_title {{$t('AGENT.GOAL_Mandatory')}}
                            v-col(cols='10' :title='agent_detail_data.goal')
                                v-textarea.span.textarea-style.mb-1(
                                    v-model='agent_detail_data.goal'
                                    no-resize
                                    hide-details,
                                    rows='2'
                                    outlined
                                    dense
                                    :disabled='!editMode'
                                    style="font-family: 'Segoe UI',SegoeUI,'Noto Sans TC', sans-serif !important;font-weight: 400; font-size: 14px;"
                                )
                        v-form(v-model='valid' ref='form')
                            div.mt-3(v-for='(item, index) in config_param')
                                // 圖片輸入
                                v-row(no-gutters v-if='item.data_type == "image_upload"')
                                    v-col(cols='2' :title='item.system_name')
                                        label.label_title {{ item.field_name }}
                                    v-col(cols='9').agent-drawer-imageinput-hint
                                        v-file-input.mb-1.span.textarea-style(
                                            v-model='ImageAttachments[index]'
                                            prepend-icon="mdi-image-multiple"
                                            :placeholder= '$t("UPGPT.WRONGTYPEINIMAGEFILE")'
                                            accept=".jpg, .jpeg, .png" 
                                            truncate-length="15" 
                                            outlined
                                            dense
                                            :rules="item.is_mandatory ? formRule.ImagemandatoryRuleRule : formRule.ImagefileRule"
                                            :disabled='!editMode'
                                            style="font-family: 'Segoe UI',SegoeUI,'Noto Sans TC', sans-serif !important;font-weight: 400; font-size: 14px;"
                                            @change='onChangeImageFile'
                                            @input='enableValidation'
                                        )
                                    v-col.d-flex.justify-center(cols='1')
                                        v-btn(@click='deleteField(index)' :disabled="addBtn_loading" plain style='width:24px; height:24px; min-width:24px; min-height:24px; padding:0;')
                                            v-icon(size='16' color='#222222') icon-remove
                                
                                // 文字輸入
                                v-row(no-gutters v-if='item.data_type == "text"')
                                    v-col(cols="2" :title='item.system_name')
                                        label.label_title {{ item.field_name }}
                                    v-col(cols='9').agent-drawer-textarea-hint
                                        v-textarea.span.textarea-style.mb-1(
                                            v-model='item.data'
                                            no-resize
                                            rows='2'
                                            outlined
                                            dense
                                            :disabled='!editMode'
                                            style="font-family: 'Segoe UI',SegoeUI,'Noto Sans TC', sans-serif !important;font-weight: 400; font-size: 14px;"
                                            :rules="item.is_mandatory ? formRule.text100mandatoryRules : formRule.text100Rules"
                                            @input='enableValidation'
                                        )
                                            template(v-slot:append)
                                    v-col.d-flex.justify-center(cols='1')
                                        v-btn(@click='deleteField(index)' :disabled="addBtn_loading" plain style='width:24px; height:24px; min-width:24px; min-height:24px; padding:0;')
                                            v-icon(size='16' color='#222222') icon-remove
                                    // 檔案上傳
                                v-row(no-gutters v-if='item.data_type == "document_upload"')
                                    v-col(cols="2" :title='item.system_name')
                                        label.label_title {{ item.field_name }}
                                    v-col(cols='9').agent-drawer-fileinput-hint
                                        v-file-input.mb-1.span.textarea-style.bg-white(
                                            prepend-icon="mdi-file-document-plus"
                                            accept=".pdf,.docx,.pptx,.xlsx"
                                            :placeholder= '$t("UPGPT.FILEUPLOADMESSAGE_IDP")'
                                            truncate-length="15"
                                            outlined
                                            dense
                                            :rules="item.is_mandatory ? formRule.FilemandatoryRule : FilefileRule"
                                            :disabled='!editMode'
                                            style="font-family: 'Segoe UI',SegoeUI,'Noto Sans TC', sans-serif !important;font-weight: 400; font-size: 14px;"
                                            v-model='FileAttachments[index]'
                                            @change='onChangeFile'
                                            @input='enableValidation'
                                        )
                                    v-col.d-flex.justify-center(cols='1')
                                        v-btn(@click='deleteField(index)' :disabled="addBtn_loading" plain style='width:20px; height:20px;')
                                            v-icon(size='16' color='#222222') icon-remove
                div
                    v-divider
                    //- //- description
                    //- v-divider.mx-0.my-2
                    //- div.pa-0.ma-0.mt-0.ml-4.pr-4 
                    //-     div(style="display: flex; flex-direction: column;")
                    //-         v-row.mt-3(no-gutters)
                    //-             v-col(cols="2")
                    //-                 label.label_title {{$t('AGENT.GOAL')}}
                    //-             v-col(cols='9' :title='agent_detail_data.goal')
                    //-                 v-textarea.span.textarea-style.mb-1(
                    //-                     v-model='agent_detail_data.goal'
                    //-                     no-resize
                    //-                     hide-details,
                    //-                     rows='2'
                    //-                     outlined
                    //-                     :disabled='!editMode'
                    //-                     style="font-family: 'Segoe UI',SegoeUI,'Noto Sans TC', sans-serif !important;font-weight: 400; font-size: 14px;"
                    //-                 )
                    //-                     template(v-slot:append)
        
                    //- 步驟
                    div
                        div(style="display: flex; align-items: center;")
                            v-img.ml-3(:src="require('@/assets/images/step.svg')" max-width="25" max-height="25")
                            span(style="font-size: 16px; font-weight: 700;") {{ $t("AGENT.STEP") }}
                        v-expansion-panels.agent_input_area.step_display_area_height.agent_detail_and_run_dialog.pl-7.pr-5.pt-2.mt-1(multiple tile bg-color="transparent" focusable=false elevation=500 v-model='step_list_expanded' style="overflow-y: auto;")
                            v-expansion-panel.mt-0(v-for="(step, i) in step_list" :key="i" v-if="i > 0" style="position: relative; border-left: 2px solid #ccc; box-shadow: none; border-bottom:1px solid #ccc;")
                                v-avatar(color='grey lighten-1' size='18' style="position: absolute; left:-10px; top: -6px;")
                                    span.d-flex()
                                        v-icon.align-center.justify-center(color="white", size="15") mdi-check
                                v-expansion-panel-header(style="padding: 0px 4px 0px 24px !important; font-size: 14px; font-weight: 700; pointer-events: none; min-height: 30px;" expand-icon="") {{ $t(getLangKeyToName('AGENT.STEP_', step)) }}
                                v-expansion-panel-content(style="font-size: 14px; color: #999;")
                                    //- Agent Dialog 下半可編輯部分
                                    template(v-if="step == 'read_document'")
                                        div {{ $t("AGENT.READ_DOCUMENT_DESCRIPTION") }}
                                        v-row(no-gutters)
                                            v-col(cols='12')
                                                v-radio-group.mt-1(v-model='agent_detail_data.agent_config[i]["config_param"]["read_option"]' mandatory dense :disabled='!editMode' style="'color: #14C6DE;'")
                                                    v-radio(:label="$t('AGENT.LABEL_PREVIOUS_STEP')" value='previous_step')
                                                    v-radio(:label="$t('AGENT.LABEL_UPGPT_KNOWLEDGE')" value='upgpt_knowledge')
                                                    //- TODO: #7701 - 原本的selector的參考
                                                    v-autocomplete(
                                                        v-if="agent_detail_data.agent_config[i]['config_param']['read_option'] == 'upgpt_knowledge'"
                                                        v-model='agent_detail_data.agent_config[i]["config_param"]["selected_files"]'
                                                        :items='filteredFiles'
                                                        no-filter
                                                        item-text='filename'
                                                        :item-value='f => f'
                                                        :placeholder='$t("AGENT.CHOOSE_FILE_HINT")'
                                                        dense
                                                        hide-details
                                                        outlined
                                                        multiple
                                                        :disabled='!editMode'
                                                        :search-input.sync='fileSearch'
                                                        @update:search-input='val => onFileSearchChange(val, i)'
                                                        @change='val => onSelectionChange(val, i)'
                                                        style="z-index: 100;"
                                                    )
                                                        template.ma-1(v-slot:selection="{ item, index}")
                                                            v-chip(
                                                                close
                                                                small
                                                                class="ma-1"
                                                                @click:close="removeFiles(item,i)"
                                                            ) {{ item.filename.length > 15 ? item.filename.slice(0, 15) + '...' : item.filename }}
                                        v-row(no-gutters).mt-0
                                            v-col(cols="3")
                                                label.step_setting {{$t("AGENT.INCLUDE_IN_CITATION")}}
                                            v-col(cols="9" style="padding-top: 0; margin-top: -8px;")
                                                v-checkbox(
                                                    v-model='agent_detail_data.agent_config[i]["config_param"]["include_in_citation"]'
                                                    :true-value="true"
                                                    :false-value="false"
                                                    :disabled='!editMode'
                                                    dense
                                                )
                                    template(v-if="step == 'think'")
                                        div {{ $t("AGENT.THINK_DESCRIPTION") }}
                                    template(v-if="step == 'search_image_by_image'")
                                        div {{ $t("AGENT.SEARCH_IMAGE_BY_IMAGE_DESCRIPTION") }}
                                        v-row(no-gutters).mt-4
                                            v-col(cols="3")
                                                label.step_setting {{$t("AGENT.SEARCH_IMAGE_BY_IMAGE_NUM_IMAGE_RETURN")}}
                                            v-col(cols='9')
                                                v-text-field(
                                                    v-model='agent_detail_data.agent_config[i]["config_param"]["num_image_return"]'
                                                    type="number"
                                                    outlined
                                                    dense
                                                    :disabled='!editMode'
                                                    :rules='formRule.numberRule'
                                                )
                                        v-row(no-gutters).mt-4
                                            v-col(cols="3")
                                                label.step_setting {{$t("AGENT.KNOWLEDGE_LIBS")}}
                                            v-col(cols='9')
                                                v-select.no-border.bg-white.mb-1(
                                                    v-model='agent_detail_data.agent_config[i]["step_knowledge_lib"]' 
                                                    return-object 
                                                    multiple 
                                                    dense 
                                                    outlined
                                                    :items='allKnowledgeList'
                                                    item-text='name'
                                                    item-value='id'
                                                    item-header='header'
                                                    :disabled='!editMode'
                                                    :placeholder= '$t("AGENT.KNOWLEDGE_MESSAGE")'
                                                    :menu-props="{closeOnClick:false}"
                                                    style="font-family: 'Segoe UI',SegoeUI,'Noto Sans TC', sans-serif !important;font-weight: 400; font-size: 14px; z-index: 100;"
                                                )
                                                    template(v-slot:selection="{ item, index}")
                                                        v-chip(
                                                            close
                                                            small
                                                            class="ma-1"
                                                            @click:close="removeKnowledges(item,i)"
                                                        ) {{ item.name.length > 15 ? item.name.slice(0, 15) + '...' : item.name }}
                                    template(v-if="step == 'search_knowledge'")
                                        div {{ $t("AGENT.SEARCH_KNOWLEDGE_DESCRIPTION") }}
                                        //- instruction prompt
                                        v-row(no-gutters).mt-4
                                            v-col(cols="3")
                                                label.step_setting {{$t("AGENT.INSTRUCTION")}}
                                            v-col(cols='9')
                                                v-textarea(
                                                    v-model='agent_detail_data.agent_config[i]["config_param"]["instruction_prompt"]'
                                                    outlined
                                                    auto-grow
                                                    dense
                                                    no-resize
                                                    rows='1'
                                                    :disabled='!editMode'
                                                )
                                        //- num of subqueries
                                        v-row(no-gutters).mt-4
                                            v-col(cols="3")
                                                label.step_setting {{$t("AGENT.SEARCH_KNOWLEDGE_NUM_OF_SUBQUERIES")}}
                                            v-col(cols='9')
                                                v-text-field(
                                                    v-model='agent_detail_data.agent_config[i]["config_param"]["num_of_subqueries"]'
                                                    type="number"
                                                    outlined
                                                    dense
                                                    :rules='formRule.numberRule'
                                                    :disabled='!editMode'
                                                )
                                        //- num of knowledge libs
                                        v-row(no-gutters).mt-4
                                            v-col(cols="3")
                                                label.step_setting {{$t("AGENT.KNOWLEDGE_LIBS")}}
                                            v-col(cols='9')
                                                v-select.no-border.bg-white.mb-5(
                                                    v-model='agent_detail_data.agent_config[i]["step_knowledge_lib"]' 
                                                    return-object 
                                                    multiple 
                                                    dense 
                                                    outlined
                                                    :items='allKnowledgeList'
                                                    item-text='name'
                                                    item-value='id'
                                                    item-header='header'
                                                    :disabled='!editMode'
                                                    :placeholder= '$t("AGENT.KNOWLEDGE_MESSAGE")'
                                                    :menu-props="{closeOnClick:false}"
                                                    style="font-family: 'Segoe UI',SegoeUI,'Noto Sans TC', sans-serif !important;font-weight: 400; font-size: 14px; z-index: 100;"
                                                )
                                                    template(v-slot:selection="{ item, index}")
                                                        v-chip(
                                                            close
                                                            small
                                                            class="ma-1"
                                                            @click:close="removeKnowledges(item,i)"
                                                        ) {{ item.name.length > 15 ? item.name.slice(0, 15) + '...' : item.name }}
                                        //- include in citation
                                        v-row(no-gutters).mt-0
                                            v-col(cols="3")
                                                label.step_setting {{$t("AGENT.INCLUDE_IN_CITATION")}}
                                            v-col(cols="9" style="padding-top: 0; margin-top: -8px;")
                                                v-checkbox(
                                                    v-model='agent_detail_data.agent_config[i]["config_param"]["include_in_citation"]'
                                                    :true-value="true"
                                                    :false-value="false"
                                                    :disabled='!editMode'
                                                    dense
                                                )
                                    template(v-if="step == 'respond'")
                                        div {{ $t("AGENT.RESPOND_DESCRIPTION") }}
                                        v-row(no-gutters).mt-4
                                            v-col(cols="3")
                                                label.step_setting {{$t("AGENT.INSTRUCTION")}}
                                            v-col(cols='9')
                                                v-textarea(
                                                    v-model='agent_detail_data.agent_config[i]["config_param"]["instruction_prompt"]'
                                                    outlined
                                                    auto-grow
                                                    dense
                                                    no-resize
                                                    rows='1'
                                                    :disabled='!editMode'
                                                )
                                        v-row(no-gutters).mt-4
                                            v-col(cols="3")
                                                label.step_setting {{$t("AGENT.OUTPUT_FORMAT")}}
                                            v-col(cols='9')
                                                v-textarea(
                                                    v-model='agent_detail_data.agent_config[i]["config_param"]["output_format_prompt"]'
                                                    outlined
                                                    auto-grow
                                                    dense
                                                    no-resize
                                                    rows='1'
                                                    :disabled='!editMode'
                                                )
                                        v-row(no-gutters).mt-4
                                            v-col(cols="3")
                                                label.step_setting {{$t("AGENT.IGNORE_LANGUAGE_SETTING")}}
                                            v-col(cols="9" style="padding-top: 0; margin-top: -8px;")
                                                v-checkbox(
                                                    v-model='agent_detail_data.agent_config[i]["config_param"]["ignore_language_setting"]'
                                                    :true-value="true"
                                                    :false-value="false"
                                                    dense
                                                    :disabled='!editMode'
                                                )
            //- 執行區
            div.portal-drawer-footer.ma-0.pa-0.py-4.shrink-0()
                .d-flex.justify-space-between.align-center.px-4
                    v-btn(@click='save()' width='80' height='30' outlined color='#14C6DE' )
                        v-progress-circular(v-if='addBtn_loading' indeterminate size='20')
                        span.d-flex.align-center(v-else)
                            span
                                v-img.mr-1(src="@/assets/images/save.png" max-height="20" max-width="20")
                            span(style="font-family: 'Segoe UI'; font-weight: 600; font-size: 14px; color: #14C6DE;") Save
    
                    v-btn.white--text(v-if='showrun' @click='runAgent()' width='115' height='30' :ripple='false' color='#14C6DE' depressed :disabled='addBtn_loading')
                        v-img.mr-1(:src="addBtn_loading ? require('@/assets/images/run-grey.svg') : require('@/assets/images/play.png')" max-height="20" max-width="20")
                        span(style="font-family: 'Segoe UI'; font-weight: 600; font-size: 14px; color: white;") Run Agent
        v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
            success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
        v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
            error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
        v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitMessageDialog(false)' @keydown.enter='onEmitMessageDialog(true)')
            message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message')
        v-dialog(v-model='showAgentFieldDialog' width='550')
            AgentFieldDialog(:agentDetailData='agent_detail_data' @emitCloseAgentFieldDialog='closeAgentFieldDialog()' @emitUpdateAgentConfig="updateAgentConfig")
        v-dialog(v-model='selectagenticondialog' max-width="300" max-height="400")
            select-agent-icon-dialog(@emitSelectAgentIconDialog='onEmitSelectAgentIconDialog' :currentIconPath='agent_detail_data.icon_path')
</template>

<script>
    import Vue from 'vue';
    import i18n from '/common/plugins/vue-i18n.js';
    import { mapState } from 'vuex';
    import successDialog from "@/components/Dialog/successDialog";
    import errorDialog from "@/components/Dialog/errorDialog";
    import messageDialog from "@/components/Dialog/messageDialog";
    import selectAgentIconDialog from "@/components/GPT_Dialog/Agent/selectAgentIconDialog";
    import KnowledgeLibraryService from "@/services/KnowledgeLibraryService";
    import UpGPTPortalDataServices from "@/services/UpGPTPortalDataServices";
    import AgentFieldDialog from "@/components/GPT_Dialog/Agent/AgentFieldDialog";
    import PreferenceService from "@/services/PreferenceService";

    export default Vue.extend({
        props: {
            lock: {
                type: Boolean,
                default: true
            },
            addBtnLoading: {
                type: Boolean,
                default: false
            },
            showrun: {
                type: Boolean,
                required: true,
            },
            agentdetail: {
                type: Object,
                required: true,
            },
            FileAttachments: {
                type: Array,
                required: true,
            },
            ImageAttachments: {
                type: Array,
                required: true,
            },
            agentmode: {
                type: String,
                required: true
            }
        },
        components: {
            selectAgentIconDialog,
            successDialog,
            errorDialog,
            messageDialog,
            AgentFieldDialog,
        },
        async created(){
            await this.getKnowledgeList();
            await this.getKnowledgeListPrivate();
            this.allKnowledgeList = [
            ...this.knowledgeList.map(k => ({ ...k, group: 'Public' })),
            // {header:'Private'},
            // ...this.knowledgeListPrivate.map(k => ({ ...k, group: 'Private' }))
            ];
            this.get_upgpt_setting();
            if (this.agentdetail && this.agentdetail.icon_path){
                this.select_icon_obj = { name: this.agentdetail.icon_path, path: this.mapping_icon_path(this.agentdetail.icon_path) }
            } else {
                this.select_icon_obj = { name: "default", path: require("@/assets/images/agent_icon/default.png") }
            }
            await this.getKnowledgeFiles(this.allKnowledgeList);
            await PreferenceService.getMaxThreadUploadFile().then((response)=>{
                this.maxThreadUploadFile = response.data;
            })
        },
        data() {
            return{
                mutexTimeoutSuccess: false,
                checktimeout: false,
                hideValidationTips: true,
                addBtn_loading: false,
                maxThreadUploadFile: 3,
                filteredFiles: [],
                labelPreviousStep: 'Previous Step',
                labelUpgptKnowledge: 'UpGPT Knowledge',
                editMode: true,
                showAgentFieldDialog: false,
                windowHeight: window.innerHeight,
                valid:true,
                ImgfileSize: true,
                FileSize: true,
                FolderSize: true,
                knowledgeList:[],
                knowledgeListPrivate:[],
                allKnowledgeList:[],
                // Initial Data
                agent_detail_data: {},
                config_param: [],
                step_list: [],
                step_list_expanded: [0,1,2,3,4,5],
                instruction: "",
                // Input Rules
                formRule: {
                    mandatoryRules:[
                        (v) => this.hideValidationTips || !!v || i18n.t('RULE.RULE_R'),
                    ],
                    text100Rules:[
                        (v) => this.hideValidationTips || /^.{0,100}$/s.test(v) || i18n.t("RULE.RULE_100"),
                    ],
                    text100mandatoryRules:[
                        (v) => this.hideValidationTips || !!v || i18n.t('RULE.RULE_R'),
                        (v) => this.hideValidationTips || /^.{0,100}$/s.test(v) || i18n.t("RULE.RULE_100"),
                    ],
                    ImagefileRule: [
                        () => { return (this.hideValidationTips || this.ImgfileSize || i18n.t('RULE.RULE_FILE_4'))},
                    ],
                    ImagemandatoryRuleRule: [
                        (v) => this.hideValidationTips || !!v || i18n.t('RULE.RULE_R'),
                        () => { return (this.hideValidationTips || this.ImgfileSize || i18n.t('RULE.RULE_FILE_4'))},
                    ],
                    FilefileRule: [
                        () => { return (this.hideValidationTips || this.FileSize || i18n.t('RULE.RULE_FILE_3', {size: this.upload_size}))},
                    ],
                    FilemandatoryRule: [
                        (v) => this.hideValidationTips || !!v || i18n.t('RULE.RULE_R'),
                        () => {
                            return (this.hideValidationTips || this.FileSize || i18n.t('RULE.RULE_FILE_3', {size: this.upload_size}))},
                    ],
                    numberRule: [(v) => this.hideValidationTips || /^[1-9]\d*$/.test(v) && Number(v) > 0 || i18n.t('RULE.RULE_R_NUM_8')],
                    // URLRules:[
                    //     (v) => !!v || i18n.t('RULE.RULE_R'),
                    //     (v) => /^(http(s):\/\/.)[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+*.~#?&//=]*)$|(^$)|null/.test(v) || i18n.t("RULE.RULE_URL"),
                    //     (v) => /^.{0,500}$/.test(v) || i18n.t("RULE.RULE_500"),
                    // ],
                },
                // Dialog
                successDialog: false,
                successMessage: "",
                errorDialog: false,
                errorMessage: "",
                messageDialog: false,
                message: "",
                edit_mode: false,
                fileSearch: '',
                allFiles: [],
                selectagenticondialog:false,
                select_icon_obj: { name: "default", path: require("@/assets/images/agent_icon/default.png") },
            }
        },
        methods: {
            enableValidation() {
                if (this.hideValidationTips) {
                    this.hideValidationTips = false
                }
            },
            onSelectionChange(val,i) {
                if (val.length > this.maxThreadUploadFile) {
                    this.agent_detail_data.agent_config[i]["config_param"]["selected_files"] = val.slice(0, this.maxThreadUploadFile);
                    this.showMessageDialog(`You can only select up to ${this.maxThreadUploadFile} files.`);
                }
            },
            onFileSearchChange(val,i) {
                const search = val
                const selected = this.agent_detail_data.agent_config[i]["config_param"]["selected_files"] || [];
                // search == '/' || 
                if (search == undefined || search == '') {
                    this.filteredFiles = Array.from(new Set([...this.allFiles, ...selected]));
                // } else if (!search.startsWith('/')) {
                //     // this.filteredFiles = [];
                //     this.filteredFiles = [...selected];
                } else {
                    // const keyword = search.slice(1);
                    const keyword = search.toLowerCase();
                    const filtered = this.allFiles.filter(f =>
                        f.filename.toLowerCase().startsWith(keyword)
                    );
                    this.filteredFiles = Array.from(new Set([...filtered, ...selected]));
                }
            },
            deleteField(index) {
                this.agent_detail_data.agent_config[0]["config_param"].splice(index, 1);
                this.FileAttachments.splice(index, 1);
                this.ImageAttachments.splice(index, 1);
            },
            openEditMode() {
                this.editMode = true;
            },
            closeEditMode() {
                this.editMode = false;
            },
            updateAgentConfig(newField) {
                const isDuplicate = this.agent_detail_data.agent_config[0]["config_param"].some(
                    (param) => param.system_name === newField.system_name
                );
                const doc_count = this.agent_detail_data.agent_config[0]["config_param"]
                .filter(item => item.data_type === "document_upload")
                .length;
                const img_count = this.agent_detail_data.agent_config[0]["config_param"]
                .filter(item => item.data_type === "image_upload")
                .length;
                
                if (isDuplicate) {
                    this.showErrorDialog("System name cannot be duplicated.")
                } else if (newField.data_type == "document_upload" && doc_count >= 3) {
                    this.showErrorDialog("You can only select up to 3 documents");
                } else if (newField.data_type == "image_upload" && img_count >= 3) {
                    this.showErrorDialog("You can only select up to 3 images");
                } else {
                    this.agent_detail_data.agent_config[0]["config_param"].push(newField);
                    this.showSuccessDialog();
                }
            },
            removeFiles(val,i) {
                this.agent_detail_data.agent_config[i]["config_param"]["selected_files"] = this.agent_detail_data.agent_config[i]["config_param"]["selected_files"].filter(v => v.id !== val.id);
            },
            removeKnowledges(val,i) {
                this.agent_detail_data.agent_config[i]["step_knowledge_lib"] = this.agent_detail_data.agent_config[i]["step_knowledge_lib"].filter(v => v.id !== val.id);
            },
            popAgentFieldDialog(){
                this.showAgentFieldDialog = true;
            },
            closeAgentFieldDialog(){
                this.showAgentFieldDialog = false;
            },
            async get_upgpt_setting(){
                let setting = await this.upgpt_image_func_setting();
                this.upload_size = setting['upload_size'] ?? 20;
            },
            validateForm() {
                if (this.$refs.form.validate()) 
                    return true;
                else 
                    return false;
            },
            async getKnowledgeList(){
                await KnowledgeLibraryService.select_list().then((response)=>{
                    this.knowledgeList = response.data.filter(el => el.active === true);
                })
            },
            async getKnowledgeListPrivate(){
                await KnowledgeLibraryService.list_private(true).then((response)=>{
                    this.knowledgeListPrivate = response.data.filter(el =>el.active === true)
                    this.knowledgeListPrivate.forEach(el => {
                        if (el.name.includes('@')) {
                            el.name = el.name.split('@')[0];
                        }
                    })
                })
            },
            async getKnowledgeFiles(allKnowledgeList){
                let user = window.localStorage.getItem('user');
                await KnowledgeLibraryService.select_files({"knowledge":allKnowledgeList, "user":user}).then((response)=>{
                    this.allFiles = response.data;
                })
            },
            onChangeImageFile(event){
                if (event != null) {
                    if (event.size > 20971520) {
                        this.ImgfileSize = false;
                    } else {
                        this.ImgfileSize = true;
                    }
                } else {
                    this.ImgfileSize = true;
                }
            },
            onChangeFile(event) {
                // this.FileSize為false表示不過
                if (event != null) {
                    this.FileSize = this.count_size_and_set_status(event.size);
                } else {
                    this.FileSize = true;
                }
            },
            count_size_and_set_status(event_size) {
              const maxSizeInMB = this.upload_size * 1024 * 1024;
              if (event_size > maxSizeInMB) {
                  return false;
              } else {
                  return true;
              }
            },
            onCloseDialog(){
                this.agent_detail_data = {};
                this.config_param = [];
                this.step_list = [];
                this.agent_detail = [];
                // 在child先清空才不會跳rule display
                this.ImageAttachments = [];
                this.FileAttachments = [];
                this.instruction = "";
                this.$emit("emitCloseAgentDrawer","editAdvanceAgent");
            },
            async save(){
                this.addBtn_loading = true;
                this.editMode = false;
                let formData = new FormData();
                for(let i in this.agent_detail_data.agent_config){
                    if(this.agent_detail_data.agent_config[i]["step_type"] === "user_input"){
                        for(let j in this.agent_detail_data.agent_config[i]["config_param"]){
                            if(this.agent_detail_data.agent_config[i]["config_param"][j]['data_type'] === "image_upload"){
                                formData.append(this.agent_detail_data.agent_config[i]["config_param"][j]['system_name'], this.ImageAttachments[j]);
                            }
                            if(this.agent_detail_data.agent_config[i]["config_param"][j]['data_type'] === "document_upload"){
                                formData.append(this.agent_detail_data.agent_config[i]["config_param"][j]['system_name'], this.FileAttachments[j]);
                            }
                        }
                    }
                }
                //  處理檔案上傳
                formData.append('agent_config', JSON.stringify(this.agent_detail_data.agent_config));
                formData.append('agent_id', this.agent_detail_data.id);
                formData.append('tenant', window.localStorage.getItem('tenant'));
                formData.append('agent_mode', this.agentmode);
                let user =  JSON.parse(window.localStorage.getItem('user'));
                let user_id = user["userid"];
                formData.append('user_id',user_id);

                // 上傳檔案API
                try {
                    const response = await UpGPTPortalDataServices.uploadAgentFiles(formData);
                    console.log(response.data);
                } catch (error) {
                    if(error == 'Error: timeout of 30000ms exceeded'){
                        this.showErrorDialog(i18n.t('AGENT_FILE_ATTACHMENT.STILL_RUN'));
                        this.mutexTimeoutSuccess = true;
                        this.checktimeout = true;
                        this.editMode = false;
                    } else {
                        console.error("上傳檔案時發生錯誤：", error);
                    }
                } finally {
                    if (!this.checktimeout){
                        this.editMode = true;
                        this.addBtn_loading = false;
                    }
                }
                if (this.agentmode == "private") {
                    await UpGPTPortalDataServices.getUserAgentDetail(this.agent_detail_data.id).then(response => {
                            let data = response.data;
                            this.agent_detail = data;
                    }).catch((response) => {
                        this.showErrorDialog(response.data);
                    });
                } else {
                    await UpGPTPortalDataServices.getAgentDefinitionDetail(this.agent_detail_data.id).then(response => {
                            let data = response.data;
                            this.agent_detail = data;
                    }).catch((response) => {
                        this.showErrorDialog(response.data);
                    });
                }
                // 連續儲存時要複製agent_detail_data沒有的key過來才不會出錯, agent_definition不要複製過來, 才save得到
                Object.keys(this.agent_detail).forEach(key => {
                    if (!(key in this.agent_detail_data) && key !== "updated_on" && key !== "updated_by" && key !== "last_access" && key !== "created_by" && key !== "agent_config") {
                        this.agent_detail_data[key] = this.agent_detail[key];
                    } else if (key == "agent_config") {
                        // 測試用
                        // const snapshot = JSON.parse(JSON.stringify(this.agent_detail_data));
                        // console.log("當下的 agent_detail_data：", snapshot);
                        // const snapshot1 = JSON.parse(JSON.stringify(this.agent_detail));
                        // console.log("當下的 agent_detail：", snapshot1);
                        this.agent_detail[key].forEach((step, stepId) => {
                            if(step["step_type"] == "user_input") {
                                step["config_param"].forEach((item, itemId) => {
                                    if(item["data_type"] == "document_upload" && this.agent_detail_data[key][stepId].config_param[itemId] && Array.isArray(item["data"])){
                                        if (item["data"].length > 0){
                                            this.agent_detail_data[key][stepId].config_param[itemId].data = item["data"];
                                        } else {
                                            this.agent_detail_data[key][stepId].config_param[itemId].data = [];
                                        }
                                    } else if (item["data_type"] == "image_upload" && this.agent_detail_data[key][stepId].config_param[itemId] && Array.isArray(item["data"])) {
                                        if (item["data"].length > 0){
                                            this.agent_detail_data[key][stepId].config_param[itemId].data = item["data"];
                                        } else {
                                            this.agent_detail_data[key][stepId].config_param[itemId].data = [];
                                        }
                                    }
                                });
                            }
                        });
                    }
                });
                let edit_data = this.agent_detail_data;
                edit_data.icon_path = this.select_icon_obj.name
                if (edit_data.agent_definition && edit_data.agent_definition != ""){
                    await UpGPTPortalDataServices.saveUserAgentDetail(edit_data.id, edit_data).then(response => {
                        let data = response.data;
                        // data.knowledges = data.linked_useragents_and_knowledge_set.map(item=> {return item.knowledge_lib});
                        // this.agent_detail_data = data;
                        data.agent_config.forEach(step => {
                            if(step["step_type"] == "user_input") {
                                step.config_param.forEach((field, index) => {
                                    if (field["data_type"] === "document_upload") {
                                        const data = field["data"];
                                        this.FileAttachments[index] = Array.isArray(data) && data.length > 0 ? data[0] : null;
                                    } else if (field["data_type"] === "image_upload") {
                                        const data = field["data"];
                                        this.ImageAttachments[index] = Array.isArray(data) && data.length > 0 ? data[0] : null;
                                    }
                                })
                            }
                        })
                        if (!this.checktimeout){
                            this.editMode = true;
                            this.addBtn_loading = false;
                        }
                        if(!this.mutexTimeoutSuccess){
                            this.showSuccessDialog();
                        }
                    }).catch((response) => {
                        this.showErrorDialog(response);
                        this.editMode = true;
                    });
                }else{
                    await UpGPTPortalDataServices.saveAgentDetail(edit_data.id, edit_data).then(response => {
                        let data = response.data;
                        // data.knowledges = data.linked_agents_and_knowledge_set.map(item=> {return item.knowledge_lib});
                        // this.agent_detail_data = data;
                        data.agent_config.forEach(step => {
                            if(step["step_type"] == "user_input") {
                                step.config_param.forEach((field, index) => {
                                    if (field["data_type"] === "document_upload") {
                                        const data = field["data"];
                                        this.FileAttachments[index] = Array.isArray(data) && data.length > 0 ? data[0] : null;
                                    } else if (field["data_type"] === "image_upload") {
                                        const data = field["data"];
                                        this.ImageAttachments[index] = Array.isArray(data) && data.length > 0 ? data[0] : null;
                                    }
                                })
                            }
                        })
                        if (!this.checktimeout){
                            this.editMode = true;
                            this.addBtn_loading = false;
                        }
                        if(!this.mutexTimeoutSuccess){
                            this.showSuccessDialog();
                        }
                    }).catch((response) => {
                        this.showErrorDialog(response);
                        this.editMode = true;
                    });
                }
                // save 完直接 close dialog
                // this.agent_detail_data = {};
                // this.config_param = [];
                // this.step_list = [];
                // this.agent_detail = [];
                // this.ImageAttachments = [];
                // this.FileAttachments = [];
                // this.instruction = "";
                // this.$emit("emitCloseAgentDrawer","editAdvanceAgent");
            },
            async runAgent(){
                this.hideValidationTips = false
                if (this.validateForm()) {
                    let run_data = JSON.parse(JSON.stringify(this.agent_detail_data));
                    let run_config_param;
                    for(let i in run_data.agent_config){
                        if(run_data.agent_config[i]["step_type"] === "user_input"){
                            for(let j in run_data.agent_config[i]["config_param"]){
                                if(run_data.agent_config[i]["config_param"][j]['data_type'] === "image_upload"){
                                    run_data.agent_config[i]["config_param"][j]['data'] = this.ImageAttachments[j]
                                }
                                if(run_data.agent_config[i]["config_param"][j]['data_type'] === "document_upload"){
                                    run_data.agent_config[i]["config_param"][j]['data'] = this.FileAttachments[j]
                                }
                            }
                            run_config_param = run_data.agent_config[i]["config_param"];
                        }
                    }
                    let sendback = {
                        type: 'Agent',
                        agent_id: run_data.id,
                        agent_name: run_data.agent_name,
                        agent_config: run_data.agent_config,
                        general_instruction: this.instruction,
                        // question: question,
                        // upload_image: this.ImageAttachments,
                        Knowledge_libs: run_data.knowledges
                    }
                    run_config_param.forEach(item => {
                        sendback[item.system_name] = item.data;
                    })
                    this.hideValidationTips = true
                    this.$emit("emitAgentDetailAndRunDrawer",sendback);
                }
            },
            // Dialog Area ----------------------------------------- [Start]
            showSuccessDialog() {
                this.successDialog = true;
            },
            onEmitSuccessDialog() {
                this.successDialog = false;
            },
            showErrorDialog(message) {
                this.errorDialog = true;
                this.errorMessage = message;
            },
            onEmitErrorDialog() {
                this.errorDialog = false;
            },
            showMessageDialog(message) {
                this.messageDialog = true;
                this.message = message;
            },
            async onEmitMessageDialog(val) {
                if(val){
                    console.log("OK")
                }
                this.messageDialog = false;
            },
            showAgentIconEditDialog() {
                this.selectagenticondialog = true;
            },
            onEmitSelectAgentIconDialog(icon_obj) {
                this.select_icon_obj = icon_obj;
                this.agentdetail.icon_path = this.select_icon_obj.name;
                this.selectagenticondialog = false;
            },
            mapping_icon_path(icon_name){
                if (icon_name == 'award') {
                    return require("@/assets/images/agent_icon/award.png")
                } else if (icon_name == 'cloud'){
                    return require("@/assets/images/agent_icon/cloud.png")
                } else if (icon_name == 'construction'){
                    return require("@/assets/images/agent_icon/construction.png")
                } else if (icon_name == 'customerservice'){
                    return require("@/assets/images/agent_icon/customerservice.png")
                } else if (icon_name == 'finance'){
                    return require("@/assets/images/agent_icon/finance.png")
                } else if (icon_name == 'generate'){
                    return require("@/assets/images/agent_icon/generate.png")
                } else if (icon_name == 'humanresource'){
                    return require("@/assets/images/agent_icon/humanresource.png")
                } else if (icon_name == 'idea'){
                    return require("@/assets/images/agent_icon/idea.png")
                } else if (icon_name == 'knowledge'){
                    return require("@/assets/images/agent_icon/knowledge.png")
                } else if (icon_name == 'message'){
                    return require("@/assets/images/agent_icon/message.png")
                } else if (icon_name == 'metal'){
                    return require("@/assets/images/agent_icon/metal.png")
                } else if (icon_name == 'policy'){
                    return require("@/assets/images/agent_icon/policy.png")
                } else if (icon_name == 'questionandanswer'){
                    return require("@/assets/images/agent_icon/questionandanswer.png")
                } else if (icon_name == 'report'){
                    return require("@/assets/images/agent_icon/report.png")
                } else if (icon_name == 'robot'){
                    return require("@/assets/images/agent_icon/robot.png")
                } else if (icon_name == 'searchimage'){
                    return require("@/assets/images/agent_icon/searchimage.png")
                } else if (icon_name == 'setting'){
                    return require("@/assets/images/agent_icon/setting.png")
                } else if (icon_name == 'shopping_cart'){
                    return require("@/assets/images/agent_icon/shopping_cart.png")
                } else if (icon_name == 'speclist'){
                    return require("@/assets/images/agent_icon/speclist.png")
                } else if (icon_name == 'translate'){
                    return require("@/assets/images/agent_icon/translate.png")
                } else if (icon_name == 'conversation'){
                    return require("@/assets/images/agent_icon/conversation.png")
                } else if (icon_name == 'record'){
                    return require("@/assets/images/agent_icon/record.png")
                } else if (icon_name == 'target'){
                    return require("@/assets/images/agent_icon/target.png")
                } else if (icon_name == 'house'){
                    return require("@/assets/images/agent_icon/house.png")
                } else if (icon_name == 'land_property'){
                    return require("@/assets/images/agent_icon/land_property.png")
                } else if (icon_name == 'mail_reply'){
                    return require("@/assets/images/agent_icon/mail_reply.png")
                } else if (icon_name == 'search_web'){
                    return require("@/assets/images/agent_icon/search_web.png")
                } else {
                    return require("@/assets/images/agent_icon/default.png")
                }
            },
        },
        computed: {
            obj(){
                const data = this.agent_detail_data.agent_config || [];
                return JSON.parse(JSON.stringify(data));
            },
            ...mapState([
                'isUpsideExtension',
            ]),
        },
        watch: {
            lock(newVal) {
                this.editMode = newVal;
            },
            addBtnLoading(newVal) {
                this.addBtn_loading = newVal; // 父層傳進來的值同步到子層
            },
            agentdetail: {
                handler(newVal){
                    this.agent_detail_data = newVal;
                    if (newVal) {
                        for(let i in this.agent_detail_data.agent_config){
                            if(this.agent_detail_data.agent_config[i]["step_type"] === "user_input"){
                                this.config_param = this.agent_detail_data.agent_config[i]["config_param"];
                            }
                        }
                        this.step_list = [];
                        for(let i in this.agent_detail_data.agent_config){
                            this.step_list.push(this.agent_detail_data.agent_config[i]["step_type"]);
                        }
                    }
                    this.step_list_expanded = this.step_list.map((_, i) => i)
                },
            },
            "agentdetail.icon_path":function(e){
                if (e){
                    this.select_icon_obj = { name: e, path: this.mapping_icon_path(e) }
                } else {
                    this.select_icon_obj = { name: "default", path: require("@/assets/images/agent_icon/default.png") }
                }
            },
            obj: {
                handler(newVal, oldVal) {
                    newVal.forEach((field, index) => {
                        if(field["step_type"] == "read_document") {
                            const selected_files = field?.config_param?.selected_files || [];
                            const old_val_length = oldVal?.[index]?.config_param?.selected_files?.length || 0;

                            if(selected_files.length > 0 && Array.isArray(oldVal) && oldVal.length === 0){
                                this.fileSearch = ''
                            }else if(selected_files.length > old_val_length) {
                                this.fileSearch = ''
                            }
                        }
                    })
                },
            }
        },
    })
</script>
<style scoped>
::v-deep(.agent-drawer-imageinput-hint .v-input .v-input__control .v-text-field__details  .v-messages .v-messages__wrapper .v-messages__message){
    margin: 2px 0 2px 37px !important;
}
::v-deep(.agent-drawer-textarea-hint .v-input .v-input__control .v-text-field__details  .v-messages .v-messages__wrapper .v-messages__message){
    margin: 2px 0 2px 0 !important;
}
::v-deep(.agent-drawer-fileinput-hint .v-input .v-input__control .v-text-field__details  .v-messages .v-messages__wrapper .v-messages__message){
    margin: 2px 0 2px 37px !important;
}
.ellipsis-single{
    display: -webkit-box;
    -webkit-line-clamp: 1; /* 部分舊版瀏覽器需要此設定 */
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
}
.knowledgelib-in-agents-chip {
    color: #666666 !important;
    font-family: 'Segoe UI','SegoeUI','Noto Sans TC', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    max-width: 100px !important;
    max-height: 20px !important;
}
.label_title {
    color:#444444;
    font-weight: 500;
    font-size: 16px;
    word-break: break-word;
    font-family: 'Segoe UI',SegoeUI,'Noto Sans TC', sans-serif !important;
}
.step_setting{
    color:#444444;
    font-weight: 500;
    font-size: 14px;
    font-family: 'Segoe UI',SegoeUI,'Noto Sans TC', sans-serif !important;
}
.step_display_area_height{
    min-height: 70%;
}
.agent_input_display_height{
    height: 220px;
}
.agent_input_area{
  overflow-y: auto !important;
  overflow-x: hidden;
}
.agent_input_area::-webkit-scrollbar {
  width: 6px; /* 調整滾動條寬度 */
}
.agent_input_area::-webkit-scrollbar-track {
  background:  #F4F4F4 !important;
}
.agent_input_area::-webkit-scrollbar-thumb {
  background: rgba(153, 153, 153, 0.3) ;
  border-radius: 10px;
}
</style>